import { useIntl } from "react-intl";
import CustomDropdown from "../../../common/CustomDropdown";
import { LandingPageOptions } from "../../../../types";
import { DEPARTMENTS, ENTERPRISE_LEVEL_SETUPS } from "../../constants";
import { DynamicIdSelectorWrapper } from "../../../../utils/styled";
import { useDynamicIdSelector } from "./useDynamicIdSelector";

export function DynamicIdSelector({
  handleLandingPageOptionsUpdate,
}: Readonly<{
  handleLandingPageOptionsUpdate: (
    landingPageOptions: LandingPageOptions,
  ) => void;
}>): JSX.Element | null {
  const intl = useIntl();

  const {
    selected,
    user,
    department,
    departmentId,
    shouldShowCompanyId,
    computedGroupOptions,
    computedDepartmentIdsOptions,
    handleClearGroupDropdown,
    handleClearDropdown,
    handleSelectedDepartmentId,
    handleSelectedGroupId,
  } = useDynamicIdSelector({
    handleLandingPageOptionsUpdate,
  });

  if (ENTERPRISE_LEVEL_SETUPS.includes(selected.setup.value)) {
    return null;
  }

  switch (department.value) {
    case DEPARTMENTS.ACCOUNTING:
      return (
        <DynamicIdSelectorWrapper>
          <CustomDropdown
            id="accountGroup-dropdown"
            label={intl.formatMessage(
              shouldShowCompanyId
                ? {
                    id: "label.companyGroup",
                    defaultMessage: "GL Company",
                  }
                : {
                    id: "label.accountingGroup",
                    defaultMessage: "Accounting Group",
                  },
            )}
            isRequired={true}
            selectedOption={selected.groupId}
            handleClear={handleClearGroupDropdown}
            hasError={selected.groupId.value === ""}
            onChange={handleSelectedGroupId}
            options={computedGroupOptions}
            customStyle={{ width: "20rem" }}
          />
        </DynamicIdSelectorWrapper>
      );

    case DEPARTMENTS.PARTS:
    case DEPARTMENTS.SERVICE:
      return (
        <DynamicIdSelectorWrapper>
          <CustomDropdown
            id="department-id-dropdown"
            label={intl.formatMessage({
              id: "label.department",
              defaultMessage: "Department",
            })}
            isRequired={true}
            selectedOption={departmentId}
            handleClear={handleClearDropdown}
            hasError={departmentId.value === ""}
            onChange={handleSelectedDepartmentId}
            options={computedDepartmentIdsOptions}
            isLoading={!user.stores}
            customStyle={{ width: "20rem" }}
          />
        </DynamicIdSelectorWrapper>
      );

    default:
      return null;
  }
}
